module.exports = __webpack_public_path__ + "img/img27.f76fd312.png";